import { defineComponent, h } from 'vue';
import ImportingGuidelines from '../ImportingGuidelines';
import { Dialog } from '@phi/components';
import Dropdown from '../Dropdown';
import { troubleshooting_messages } from '../../state/modals';

export default defineComponent({
    props: {
        show: { required: true, type: Boolean},
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    watch: {
        show(value: typeof this.show) {
            if (!value)
                troubleshooting_messages.length = 0;
        }
    },

    render() {
        return h(Dialog, {
            show: this.show,
            'onUpdate:show': x => this.$emit('update:show', x),
            onClose: () => this.$emit('update:show', false),
            id: 'importTroubleshootingModal',
            title: 'Import Troubleshooting',
            width: 'wider',
            confirm_label: null,
        }, () => [
            h('section', null, [
                h('p', null, 'While importing, the following errors were encountered:'),

                h('ul', null, troubleshooting_messages.map(x => h('li', null, x))),
            ]),

            h('section', {
                style: {
                    marginTop: '3rem',
                },
            }, [
                h(Dropdown, {
                    cursor: 'help',
                    title: 'ⓘ Helpful tips',
                    class: 'mt-3',
                }, () => h(ImportingGuidelines)),
            ]),
        ]);
    }
});
